import { t } from 'i18next';
import { ofType } from 'redux-observable';
import { of, timer } from 'rxjs';
import { filter, mergeMap, switchMap, takeUntil } from 'rxjs/operators';

import {
  DynamicScreens,
  FinalStates,
  ResultMessageTypes,
} from '@cashier/cashier-model';

import { setActiveScreen } from '../../customerInformation';
import { setPaymentResult } from '../../paymentResult';
import { confirmationTimeout } from './paymentConfirmation.slice';

const CONFIRMATION_TIMEOUT_MS = 15 * 60 * 1000;

export const confirmationTimerEpic = (action$: any) =>
  action$.pipe(
    ofType(setActiveScreen.type),
    filter(
      (action: { payload: DynamicScreens }) =>
        action.payload === DynamicScreens.ConfirmationForm,
    ),
    switchMap(() =>
      timer(CONFIRMATION_TIMEOUT_MS).pipe(
        mergeMap(() =>
          of(
            confirmationTimeout(),
            setPaymentResult({
              finalState: FinalStates.ERROR,
              message: {
                content: t('failedTransaction.message'),
                type: ResultMessageTypes.STRING,
              },
            }),
          ),
        ),
        takeUntil(
          action$.pipe(
            ofType(setActiveScreen.type),
            filter(
              (action: { payload: DynamicScreens }) =>
                action.payload !== DynamicScreens.ConfirmationForm,
            ),
          ),
        ),
      ),
    ),
  );
